import Layout from '@/components/templates/Shared/Layout/Layout'
import MegaMenu from '@/components/MegaMenu/MegaMenu'
import { helmet } from '@/data/helmet'
import { configurationsService } from '@/shared/ConfigurationService'
import { DIDOMI_API_KEY } from '@/shared/constants'
import ContextProvider from '@/shared/contexts/ContextProvider'
import { initAPM } from '@/utils/elasticAPM'
import { DidomiSDK } from '@didomi/react'
import PlausibleProvider from 'next-plausible'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import Script from 'next/script'
import { useEffect } from 'react'
import '../styles/globals.scss'
import '@transverse/footer/styles.css'

const App = ({ Component, pageProps, fragment }) => {
  const Footer: any = dynamic(() => import('@transverse/footer'), {
    ssr: false
  })
  const { metas, canonicalLink } = helmet

  useEffect(() => {
    initAPM()
  }, [])

  const domain = typeof window !== 'undefined' ? window.document.location.hostname : 'transfert.free.fr'

  return (
    <>
      <Head>
        <link rel="icon" href="/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
        <title>Free Transfert - Service d'envoi de fichiers</title>
        {metas && metas.map((meta, index) => <meta {...meta} key={`meta-tag-${index}`} />)}
        {canonicalLink && <link rel="canonical" href={canonicalLink} />}
      </Head>
      <Script src="/env-config.js" strategy="beforeInteractive" />
      <section className="w-full">
        {typeof window !== 'undefined' && <DidomiSDK apiKey={DIDOMI_API_KEY} iabVersion={1} gdprAppliesGlobally />}
        <MegaMenu fragment={fragment} />
        <PlausibleProvider
          domain={domain}
          customDomain={configurationsService.PLAUSIBLE_DOMAIN}
          selfHosted={true}
          trackLocalhost={true}
          taggedEvents={true}
          enabled={true}
        >
          <ContextProvider>
            <Layout>
              <Component {...pageProps} />
            </Layout>
          </ContextProvider>
        </PlausibleProvider>
        <Footer project="free-transfert" mentions={[]} extraMentions={[]} />
      </section>
    </>
  )
}

// Fetch serveur du fragment méga-menu (Pages Router : pas d'ISR sur _app → cache module
// 60s côté serveur). Sur navigation client, on ne refetch pas : le composant garde son
// fragment initial. La donnée sert au SSR + à l'hydratation (cohérence client/serveur).
App.getInitialProps = async () => {
  if (typeof window !== 'undefined') return {}
  const { getMegaMenuFragment } = await import('@/services/megaMenuFragment')
  return { fragment: await getMegaMenuFragment() }
}

export default App
